<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
document.addEventListener("DOMContentLoaded", function() {
  var chatButton = document.querySelector('#button[data-testid="widgetButton"]');
  if(chatButton) {
    chatButton.style.marginBottom = "30px";
    chatButton.style.bottom = "30px";
  }
});
